import { AbstractControl, FormControl, FormGroup } from '@angular/forms';

export class FormHelper {
  public static markAllAsDirty(form: FormGroup): void {
    const { controls } = form;
    const keys = Object.keys(controls);

    for (const key of keys) {
      if (controls.hasOwnProperty(key)) {
        const control = controls[key];
        control.markAsDirty();
      }
    }
  }

  public static getErrorMessage(key: string, control: FormControl | AbstractControl): string {
    let result: string;

    switch (true) {
      case control.hasError('required'):
      case control.hasError('invalidRecaptcha'):
        result = `"${key}" is required field.`;
        break;
      case control.hasError('email'):
        result = 'Invalid email.';
        break;
      case control.hasError('url'):
      case control.hasError('pattern'):
        result = 'Invalid value format.';
        break;
      case control.hasError('valuesNotMatch'):
        //result = `"${key}" not match with password.`;
        result = `Does not match.`;
        break;
      case control.hasError('valuesMatch'):
        result = `"${key}" match with old password.`;
        break;
      case control.hasError('minlength'):
        result = `"${key}" should be minimum ${control.errors.minlength.requiredLength} characters long,
          actual length ${control.errors.minlength.actualLength}.`;
        break;
      case control.hasError('maxlength'):
        result = `"${key}" should be maximum ${control.errors.maxlength.requiredLength} characters long,
          actual length ${control.errors.maxlength.actualLength}.`;
        break;
      case control.hasError('password'):
        result = `"${key}" should contain at least one lowercase and at least one uppercase or one number.`;
        break;
      case control.hasError('pin'):
        result = `"${key}" must be 6 digits.`;
        break;
      case control.hasError('message'):
        result = control.errors.message;
        break;
      default:
        result = 'Invalid input';  //'something went wrong.';
    }

    return result;
  }
}
